/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  's-normal': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0zm5.128 7.45L9.05 13.526a.7.7 0 01-.255.163.703.703 0 01-.766-.153l-3.148-3.148a.703.703 0 11.994-.995l2.66 2.66 5.598-5.598a.703.703 0 11.994.995z" _fill="#14c9c9"/>'
  }
})
